import { BUSINESS } from '../site';

// Rendered on the homepage AND emitted verbatim as FAQPage JSON-LD, so the two always match.
// Every answer must be something Flip Ready has confirmed — see the TODO notes before editing.
export const FAQS: { question: string; answer: string }[] = [
  {
    question: 'What areas do you serve?',
    answer:
      'We clean offices and commercial spaces in Fredericksburg, Stafford County (including Falmouth), Spotsylvania County, King George, Caroline County, Locust Grove and Northern Virginia. If you’re nearby and not sure whether you’re in range, give us a call.',
  },
  {
    question: 'Can you clean after our business hours?',
    answer:
      'Yes. After-hours cleaning is what we do best. We work around your business hours so there’s no disruption, and your team walks into a clean, refreshed workspace the next morning.',
  },
  {
    question: 'Are you insured?',
    answer: 'Yes. Flip Ready is fully insured and bonded, and our cleaners are background-checked.',
  },
  {
    question: 'Do you bring your own cleaning supplies?',
    answer: 'Yes. Our team arrives on schedule with all of the supplies needed to clean your space.',
  },
  {
    question: 'Do I have to sign a long-term contract?',
    // TODO(arly): replace with real contract terms (minimum length, cancellation notice).
    answer:
      'We offer daily, weekly, bi-weekly and monthly cleaning plans, and quotes are always free with no obligation. We’ll walk you through the terms of your plan when we prepare your quote.',
  },
  {
    question: 'How do I get a quote?',
    answer: `Call or text ${BUSINESS.phoneDisplay} or email ${BUSINESS.email}. Tell us a little about your space and how often you’d like it cleaned, and we’ll get back to you within 24 hours with a free, no-obligation quote.`,
  },
];
